import { getConfigManager } from '../../config';
import { Decimal, ZERO } from '../../datastructures';
import { Nullable } from '../../interfaces';
import { walletAddressAtom } from '../wallet';
import accountsAtom from './accountsAtom';
import nostraTokenListAtom from './nostraTokenListAtom';
import assetTokenRatesAtom from './assetTokenRatesAtom';
import nostraTokenBalancesAtom from './nostraTokenBalanceAtom';
import { createAsyncAtom } from '../../lib/state';

export interface AccountTotalDebtMap {
  [walletAddressAccountId: string]: Nullable<Decimal>;
}

const accountTotalDebtAtom = createAsyncAtom(async get => {
  const accounts = await get(accountsAtom);
  const nostraTokens = await get(nostraTokenListAtom);
  const walletAddress = await get(walletAddressAtom);
  const nostraTokenBalances = await get(nostraTokenBalancesAtom);
  const assetTokenRates = await get(assetTokenRatesAtom);

  if (!walletAddress) {
    return {};
  }

  const configManager = getConfigManager();

  const result: AccountTotalDebtMap = {};
  accounts.forEach((subAccountName, accountId) => {
    if (!subAccountName) {
      return;
    }

    nostraTokens.forEach(nostraToken => {
      try {
        // Do not count non debt tokens when calculating total debt for a account
        if (nostraToken.variant !== 'debt') {
          return;
        }

        const accountTotalDebtKey = `${walletAddress}-${accountId}`;
        const tokenBalanceKey = `${walletAddress}-${accountId}-${nostraToken.address}`;
        const tokenRate = assetTokenRates.rate[configManager.getNostraTokenAssetAddress(nostraToken.address)];
        const tokenBalance = nostraTokenBalances[tokenBalanceKey];

        if (!tokenRate || !tokenBalance) {
          return;
        }

        result[accountTotalDebtKey] = (result[accountTotalDebtKey] ?? ZERO).add(tokenBalance.mul(tokenRate));
      } catch (error) {
        console.error(`useAccountTotalDebt - error calculating total debt for ID ${accountId}`, error);
      }
    });
  });

  return result;
});
export default accountTotalDebtAtom;
